import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { outletTypeJson } from "../../../DynamicFormsJson/MastersJSON/outletType";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import endpoint from "../../../config/endpoints";
import { noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class OutletTypeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url:
            endpoint.outletType + "/by-id?outletTypeId=" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            localStorage.getItem("subChannelWiseOutletType") == 1
              ? this.setState({
                  DataToSet: [
                    {
                      xs: 12,
                      sm: 6,
                      md: 6,
                      lg: 6,
                      label: "Sub Channel",
                      value:
                        data.data !== null && data.data.subChannelName !== null
                          ? data.data.subChannelName
                          : "",
                    },
                    {
                      xs: 12,
                      sm: 6,
                      md: 6,
                      lg: 6,
                      label: " Name",
                      value:
                        data.data !== null && data.data.name !== null
                          ? data.data.name
                          : "",
                    },
                    {
                      xs: 12,
                      sm: 6,
                      md: 6,
                      lg: 6,
                      label: "Short Name",
                      value:
                        data.data !== null && data.data.shortName !== null
                          ? data.data.shortName
                          : "",
                    },
                  ],
                })
              : this.setState({
                  DataToSet: [
                    {
                      xs: 12,
                      sm: 6,
                      md: 6,
                      lg: 6,
                      label: " Name",
                      value:
                        data.data !== null && data.data.name !== null
                          ? data.data.name
                          : "",
                    },
                    {
                      xs: 12,
                      sm: 6,
                      md: 6,
                      lg: 6,
                      label: "Short Name",
                      value:
                        data.data !== null && data.data.shortName !== null
                          ? data.data.shortName
                          : "",
                    },
                  ],
                });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Outlet Type View"}
            fieldMeta={[]}
            apiBaseURL={outletTypeJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(OutletTypeView);
